import * as React from 'react';
import { Box } from '@mui/material';

import { EnhancedTable } from 'components';
import { feedbacksTableColumns } from 'configs';
import { convertFeedbacksToTableData } from 'utils';
import { useFeedbacks } from './feedbacks.hook';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';

interface FeedbackPageProps {}

export const FeedbackPage: React.FC<FeedbackPageProps> = () => {
  const dispatch = useAppDispatch();
  const [loading, feedback] = useFeedbacks();

  React.useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Feedback' }));
  }, []);

  return (
    <Box sx={{ padding: 3 }}>
      <EnhancedTable
        config={{ toolbar: false, rowCheckable: false }}
        loading={loading}
        loadingLabel={'Loading feedbacks'}
        noDataLabel={'No feedback'}
        data={feedback}
        convertFunctionForDataToTableData={convertFeedbacksToTableData}
        headColumns={feedbacksTableColumns}
        columnKeys={['date', 'zone', 'name', 'email', 'phone', 'message', 'rating']}
        styles={{ tableStyle: { minWidth: 0 } }}
        initialRowsPerPage={10}
        visiblePagination
        rowActions={{}}
      />
    </Box>
  );
};
